var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-content-loading',_vm._b({attrs:{"width":600,"height":225}},'vue-content-loading',_vm.$attrs,false),[_c('rect',{attrs:{"x":"0","y":"0","rx":"1","ry":"1","width":"100%","height":"200"}})])}
var staticRenderFns = []

export { render, staticRenderFns }